/**
 * Test if a given string is empty
 *
 * @package Utils
 * @noapi
 * @example
 * lxIsStringEmpty('Hi') // false
 * lxIsStringEmpty('') // true
 * lxIsStringEmpty(undefined) // true
 * lxIsStringEmpty(null) // true
 */
export function lxIsStringEmpty(s?: string): boolean {
  return !s || s.length === 0;
}

/**
 * @deprecated Use {@link lxIsStringEmpty} instead.
 * @package Utils
 */
export function isStringEmpty(s?: string): boolean {
  return lxIsStringEmpty(s);
}

/**
 * Test if a given string is NOT empty
 *
 * @package Utils
 * @noapi
 * @example
 * lxIsStringNotEmpty('Hi') // true
 * lxIsStringNotEmpty('') // false
 * lxIsStringNotEmpty(undefined) // false
 * lxIsStringNotEmpty(null) // false
 */
export function lxIsStringNotEmpty(s?: string): s is string {
  return !lxIsStringEmpty(s);
}

/**
 * @deprecated Use {@link lxIsStringNotEmpty} instead.
 * @package Utils
 */
export function isStringNotEmpty(s?: string): s is string {
  return lxIsStringNotEmpty(s);
}

/**
 * Test if a given array is empty
 *
 * @package Utils
 * @noapi
 * @example
 * lxIsArrayEmpty([]) // true
 * lxIsArrayEmpty([1,2,3]) // false
 * lxIsArrayEmpty(undefined) // true
 */
export function lxIsArrayEmpty<T>(arr?: Array<T>): boolean {
  return !arr || arr.length === 0;
}

/**
 * @deprecated Use {@link lxIsArrayEmpty} instead.
 * @package Utils
 */
export function isArrayEmpty<T>(arr?: Array<T>): boolean {
  return lxIsArrayEmpty(arr);
}

/**
 * Test if a given array is NOT empty
 *
 * @package Utils
 * @noapi
 * @example
 * lxIsArrayNotEmpty([]) // false
 * lxIsArrayNotEmpty([1,2,3]) // true
 * lxIsArrayNotEmpty(undefined) // false
 */
export function lxIsArrayNotEmpty<T>(arr?: Array<T>): arr is Array<T> {
  return !lxIsArrayEmpty(arr);
}

/**
 * @deprecated Use {@link lxIsArrayNotEmpty} instead.
 * @package Utils
 */
export function isArrayNotEmpty<T>(arr?: Array<T>): arr is Array<T> {
  return lxIsArrayNotEmpty(arr);
}
